/* eslint-disable no-nested-ternary */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import ExternalRedirect from '../LoginView/ExternalRedirect';

class Kerberos extends React.Component {
  constructor(props) {
    super(props);
    const { clearLoginStatus } = this.props;
    clearLoginStatus();
  }

  componentDidMount() {
    const { postLogin } = this.props;
    postLogin();
  }

  render() {
    const { loginStatus, redirectTo, invalidLicense, msg } = this.props;
    if (loginStatus) {
      return (<ExternalRedirect loc={redirectTo} />);
    }
    return (
      <div>
        {invalidLicense
            ? (msg === 'License Expired' ? <FormattedMessage id="messages.expired.license" />
                    : (msg === 'License Unavailable' ? <FormattedMessage id="messages.unavailable.license" />
                       : 'This is Kerberos Enabled Application'))
            : 'This is Kerberos Enabled Application'}
      </div>
    );
  }
}

Kerberos.defaultProps = {
  redirectTo: '',
  invalidLicense: false,
  msg: ''
};

Kerberos.propTypes = {
  loginStatus: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string,
  postLogin: PropTypes.func.isRequired,
  clearLoginStatus: PropTypes.func.isRequired,
  invalidLicense: PropTypes.bool,
  msg: PropTypes.string
};

export default Kerberos;